import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, OnDestroy, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { FormatPricePipe } from '../../../../shared/format-price.pipe';
import { InvestmentsSimulationService } from '../investments-simulation.service';
import { InvestmentsSimulationEventType } from '../investments-simulation.event.type';
import { InvestmentOption } from '../../models/investmentOption';
import { Simulation } from '../../models/simulation';
import { ListItem } from '../../../../shared/list-confirmation/model/list-item';
import { EventTypes } from '../../../../shared/EventTypes';
import { AutenticationService } from '../../../../autentication/autentication.service';
import { Auth } from '../../../../autentication/Auth';
import { Limit } from '../../../limits/models/limits';
import * as moment from 'moment';
import { format } from 'util';
import { PercentPipe } from '@angular/common';
import { ThemeService } from '../../../../shared/theme-service/theme.service';

@Component({
	selector: 'app-investments-confirmation',
	templateUrl: './investments-confirmation.component.html',
	styleUrls: ['./investments-confirmation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class InvestmentsConfirmationComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() simulationData: Simulation;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() setTitleSubtitle: EventEmitter<any> = new EventEmitter<any>();

	private view = '[data-component="investments-confirmation"]';
	private confirmList: Array<ListItem> = [];
	private sendConfirmedInvestiment = false;
	private noAuthorization = false;
	public form: FormGroup;
	public active = false;
	public dataLimits: Array<Limit>;
	public disabled = false;
	public isAttendant = false;

	constructor(
		private investmentsSimulationService: InvestmentsSimulationService,
		private autenticationService: AutenticationService,
		private themeService: ThemeService) {
	}

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();

		this.noAuthorization = Auth.getInstance().getUser().rule !== 'TRANSACIONAR';

		AppEventDispatcher.listen(InvestmentsSimulationEventType.STEPS.INVESTMENTS_CONFIRMATION, data => {
			if (data.show) {
				this.active = true;
				this.loadLimits();
			} else {
				this.hide();
			}
		});

		AppEventDispatcher.listen(InvestmentsSimulationEventType.SEND.INVESTMENTS_CONFIRMATION_SEND, () => {
			this.send();
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(InvestmentsSimulationEventType.STEPS.INVESTMENTS_CONFIRMATION);
		AppEventDispatcher.removeListener(InvestmentsSimulationEventType.SEND.INVESTMENTS_CONFIRMATION_SEND);
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
		this.setForm.emit(this.form);

		if (this.sendConfirmedInvestiment) {

			if (this.noAuthorization) {
				this.preload(false);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Apenas clientes com perfil Autorizador podem realizar essa transação' });
				return;
			}

			this.send();
		}
	}

	show() {
		this.buildConfirmList();

		const interval = setInterval(() => {

			if ($(this.view).length > 0) {

				this.setTitleSubtitle.emit({
					title: 'Confirmação de Simulação de Investimentos',
					subtitle: 'Simule e contrate o melhor investimento para você',
				});

				const containerHeight = this.getStepHeight();

				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				clearInterval(interval);
			}

		}, 10);
	}

	hide() {
		TweenMax.delayedCall(1, () => {

			AppEventDispatcher.dispatch(InvestmentsSimulationEventType.STEPS.INVESTMENTS_SUMMARY, { show: true });

			TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});
		});
	}

	addAuthToken() {
		Auth.passToken = this.form.value.token ? this.form.value.token : '';
		Auth.assinaturaEletronica = this.form.value.eletronicSignature ? this.form.value.eletronicSignature : '';
	}

	send() {
		if (this.noAuthorization) {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {
				msg: 'Apenas clientes com perfil Autorizador podem realizar essa transação' });
			AppEventDispatcher.dispatch(InvestmentsSimulationEventType.ERROR, {
				step: InvestmentsSimulationEventType.SEND.INVESTMENTS_CONFIRMATION_SEND });
			return;
		}

		this.submited = true;
		if (this.form.valid) {

			this.preload(true);
			this.submited = false;
			this.disabled = true;

			let time = 1;
			const timeLoader = setInterval(() => {
				time++;
			}, 1000);

			this.addAuthToken();

			this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(d => {
				if (d.Sucesso) {

					this.preload(true);

					let secondTime = 1;
					const secondTimeLoader = setInterval(() => {
						secondTime++;
					}, 1000);

					this.investmentsSimulationService.doInvestment(this.simulationData.option).subscribe( data => {

						this.simulationData.success = data.status === "SUCCESS";
						this.simulationData.message = data.messages.join(`\n`);
						this.disabled = false;
						this.checkAfterSend(timeLoader, time);
						this.hide();
					}, error => {
						if (error.error && error.error.Tipo !== 'tokenDatablinkValidado') {
							this.simulationData.success = false;
							this.simulationData.message = error.error.messages.join(`\n`);
							this.checkAfterSend(timeLoader, time);
							this.disabled = false;
							this.hide();
						} else {
							this.simulationData.success = false;
							this.disabled = false;
							this.checkAfterSend(timeLoader, time);
							AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
							AppEventDispatcher.dispatch(InvestmentsSimulationEventType.ERROR, {
								step: InvestmentsSimulationEventType.SEND.INVESTMENTS_CONFIRMATION_SEND });
						}
					});
				}
			}, error => {
				this.preload(false);
				this.disabled = false;
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				AppEventDispatcher.dispatch(InvestmentsSimulationEventType.ERROR, {
					step: InvestmentsSimulationEventType.SEND.INVESTMENTS_CONFIRMATION_SEND });
			});
		}
	}

	loadLimits() {
		this.preload(true);

		this.investmentsSimulationService.getDataLimits().subscribe( data => {
			data = data.filter((e) => {
				return e;
			});
			this.dataLimits = data;
			this.active = true;
			this.show();
			this.preload(false);

		}, error => {
			this.preload(false);

			if (error.error !== undefined) {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			}
		});
	}

	checkAfterSend(timeLoader, time, error = null) {

		if (error) {
			AppEventDispatcher.dispatch(InvestmentsSimulationEventType.ERROR,
				{ step: InvestmentsSimulationEventType.SEND.INVESTMENTS_CONFIRMATION_SEND });
		}

		if (time > 3) {
			this.preload(false);
		}	else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false);
			});
		}
		clearInterval(timeLoader);
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	buildConfirmList() {

		const FP = new FormatPricePipe();
		const FPercent = new PercentPipe('pt-BR');
		if (this.simulationData.option.paperTp === 2) {
			this.confirmList.push(new ListItem('Titulo:', this.simulationData.option.description));
			this.confirmList.push(new ListItem('Investimento:', FP.transform(this.simulationData.option.mainValue, false), 'cls_mask'));
			// this.confirmList.push(new ListItem('Impostos:',
			// FP.transform(String(this.simulationData.option.IOF + this.simulationData.option.IR))));
			this.confirmList.push(new ListItem('Aplicação:', moment().format('DD/MM/YYYY')));
			this.confirmList.push(new ListItem('Vencimento:', this.simulationData.option.finalDate));
			this.confirmList.push(new ListItem('Taxa:', String(this.simulationData.option.rentability), 'cls_mask'));
			// this.confirmList.push(new ListItem('IR sobre o investimento:', FPercent.transform(this.simulationData.option.IR/100, '1.1-2')));
		} else {
			this.confirmList.push(new ListItem('Titulo:', this.simulationData.option.description));
			this.confirmList.push(new ListItem('Investimento:', FP.transform(this.simulationData.option.mainValue, false), 'cls_mask'));
			this.confirmList.push(new ListItem('Rendimento:', FP.transform(String(this.simulationData.option.yeld), false), 'cls_mask'));
			this.confirmList.push(new ListItem('Resgate bruto:', FP.transform(
			String(this.simulationData.option.mainValue + this.simulationData.option.yeld), false), 'cls_mask'));
			this.confirmList.push(new ListItem('Impostos:', FP.transform(String(this.simulationData.option.IOF +  this.simulationData.option.IR)), 'cls_mask'));
			this.confirmList.push(new ListItem('Resgate líquido:', String(this.simulationData.option.liquid), 'cls_mask'));
			this.confirmList.push(new ListItem('Aplicação:', moment().format('DD/MM/YYYY')));
			this.confirmList.push(new ListItem('Vencimento:', this.simulationData.option.finalDate));
			this.confirmList.push(new ListItem('Taxa:', String(this.simulationData.option.rentability), 'cls_mask'));
			// this.confirmList.push(new ListItem('IR sobre o investimento:', String(this.simulationData.option.IR)));
		}

		this.simulationData.resumeList = this.confirmList;
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="investments-simulation"] .content', show: active, delay: delay});
	}

	getMessageConfirmedInvestiment(message: boolean) {
		this.sendConfirmedInvestiment = message;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-simulation/investments-confirmation/investments-confirmation.component.ts